import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { CadensSharedModule } from '../../shared';
import {CadensBlocksModule} from '../blocks/blocks.module';

import {
    UserEnEchangeService,
} from './';


@NgModule({
    imports: [
        CadensSharedModule,
        CadensBlocksModule
   ],
    declarations: [
    ],
    entryComponents: [
    ],
    providers: [
        UserEnEchangeService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensUserEnEchangeModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/user-en-echange/user-en-echange.module.ts